export default function ForgotPasswordView() {
    return (
        <div>
            ForgotPassword
        </div>
    );
}